<template>
    <v-container grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <v-layout row wrap>
                    <v-flex xs12 md4 class="text-xs-center">
                        <v-card style="border-radius: 10px">
                            <v-container>
                                <v-layout row wrap align-center>
                                    <v-flex xs12 md4>
                                        <v-img height="100px"
                                               src="/static/svgImages/farmer vector.svg"
                                               lazy-src="/static/svgImages/farmer vector.svg"
                                               aspect-ratio="1"
                                               contain
                                        >
                                        </v-img>
                                    </v-flex>
                                    <v-flex xs12 md8>
                                        <span style="font-size: 48px">{{producers.length}}</span><br>
                                        <span style="font-size: 22px">Producteurs</span>

                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card>
                        <v-layout row justify-center>
                            <v-dialog v-model="producerDialog" persistent max-width="700">
                                <v-btn icon dark class="primary" slot="activator" large style="top: -30px"><b><v-icon large>add</v-icon></b></v-btn>
                                <v-card style="border-radius: 10px" class="pa-5">
                                    <v-card-title style="font-size: 22px">Ajoutez un producteur ici</v-card-title>
                                    <v-flex xs12>
                                        <v-form class="ma-0" ref="form" v-model="valid" lazy-validation>
                                            <v-text-field
                                                    solo
                                                    v-model="producerName"
                                                    label="Nom du producteur"
                                                    :rules="nameRules"
                                                    type="text"
                                                    color="primary"
                                            >
                                            </v-text-field>
                                            <v-flex xs12 class="text-xs-center">
                                                <v-btn @click="onPickFile" dark class="primary">Upload Image</v-btn>
                                                <input type="file" required ref="fileInput" style="display: none" accept="image/*" @change="onFilePicked">
                                            </v-flex>
                                            <v-flex xs12 class="text-xs-center">
                                                <v-img height="200px" :src="producerImageUrl"  :lazy-src="producerImageUrl" aspect-ratio="1">
                                                </v-img>
                                            </v-flex>
                                            <v-autocomplete
                                                    solo
                                                    v-model="state"
                                                    :items="states"
                                                    label="Province"
                                                    persistent-hint
                                            >
                                            </v-autocomplete>
                                            <v-text-field
                                                    solo
                                                    multi-line
                                                    v-model="description1"
                                                    label="Description 1"
                                                    type="text"
                                                    required
                                                    :rules="description"
                                            >
                                            </v-text-field>
                                            <v-text-field
                                                    solo
                                                    multi-line
                                                    v-model="description2"
                                                    label="Description 2"
                                                    type="text"
                                            >
                                            </v-text-field>
                                            <v-text-field
                                                    solo
                                                    multi-line
                                                    v-model="description3"
                                                    label="Description 3"
                                                    type="text"
                                            >
                                            </v-text-field>
                                            <v-text-field
                                                    solo
                                                    v-model="phoneNumber"
                                                    label="Numéro de téléphone"
                                                    type="tel"
                                                    :rules="phoneRules"
                                                    color="primary"
                                            >
                                            </v-text-field>
                                            <v-text-field
                                                    solo
                                                    v-model="email"
                                                    label="Adresse E-mail"
                                                    type="email"
                                                    required
                                                    :rules="emailRules"
                                            >
                                            </v-text-field>
                                            <v-flex xs12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 md6 class="pr-1">
                                                        <v-btn block dark class="primary" @click="registerProducer"><b>Inscrir</b></v-btn>
                                                    </v-flex>
                                                    <v-flex xs12 md6 class="pl-1">
                                                        <v-btn block @click.native="producerDialog = !producerDialog"><b>Annuler</b></v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-form>
                                    </v-flex>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 md4 class="text-xs-center">
                        <v-card style="border-radius: 10px">
                            <v-container>
                                <v-layout row wrap align-center>
                                    <v-flex xs12 md4>
                                        <v-img height="100px"
                                               src="/static/svgImages/farmer vector.svg"
                                               lazy-src="/static/svgImages/farmer vector.svg"
                                               aspect-ratio="1"
                                               contain
                                        >
                                        </v-img>
                                    </v-flex>
                                    <v-flex xs12 md8>
                                        <span style="font-size: 48px">{{products.length}}</span><br>
                                        <span style="font-size: 22px">Produits</span>
                                        <span style="font-size: 22px"></span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card>
                        <v-layout row justify-center>
                            <v-dialog v-model="productDialog" persistent max-width="700">
                                <v-btn icon dark class="primary" slot="activator" large style="top: -30px"><b><v-icon large>add</v-icon></b></v-btn>
                                <v-card style="border-radius: 10px" class="pa-5">
                                    <v-card-title style="font-size: 22px">Ajoutez un produit ici</v-card-title>
                                    <v-flex xs12>
                                        <v-form class="ma-0" ref="form1" v-model="valid" lazy-validation>
                                            <v-text-field
                                                    solo
                                                    v-model="productName"
                                                    label="Nom du produit"
                                                    :rules="nameRules"
                                                    type="text"
                                                    color="primary"
                                            >
                                            </v-text-field>
                                            <v-autocomplete
                                                    solo
                                                    v-model="productProducer"
                                                    :items="producersArray"
                                                    label="Producteur"
                                                    persistent-hint
                                            >
                                            </v-autocomplete>
                                            <v-autocomplete
                                                    solo
                                                    v-model="productCategory"
                                                    :items="categoryNames"
                                                    label="Categorie"
                                                    persistent-hint
                                            >
                                            </v-autocomplete>
                                            <v-flex xs12 class="text-xs-center">
                                                <v-btn @click="onPickFile" dark class="primary">Upload Image</v-btn>
                                                <input type="file" required ref="fileInput" style="display: none" accept="image/*" @change="onFilePicked">
                                            </v-flex>
                                            <v-flex xs12 class="text-xs-center">
                                                <v-img height="200px" :src="producerImageUrl"  :lazy-src="producerImageUrl" aspect-ratio="1">
                                                </v-img>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 md5 class="pr-1">
                                                        <v-text-field
                                                                solo
                                                                v-model="productPrice"
                                                                suffix="CDF"
                                                                type="number"
                                                                label="Prix"
                                                                required
                                                                :rules="priceRules"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 md4 class="pl-1">
                                                        <v-text-field
                                                                solo
                                                                v-model="soldAs"
                                                                label="Vendu en"
                                                                type="text"
                                                                required
                                                                :rules="name"
                                                        >
                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 md3 class="pl-1">
                                                        <v-text-field
                                                                solo
                                                                v-model="soldAsOf"
                                                                label="De"
                                                                type="text"
                                                                required
                                                        >
                                                        </v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-layout row wrap>
                                                    <v-flex xs md6 class="pr-1">
                                                        <v-text-field
                                                                solo
                                                                v-model="available"
                                                                label="Disponible"
                                                                type="number"
                                                                required
                                                        >
                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs md6 class="pl-1">
                                                        <v-text-field
                                                                solo
                                                                v-model="discount"
                                                                label="Discompte"
                                                                type="number"
                                                                required
                                                        >
                                                        </v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-layout row wrap>
                                                    <v-flex xs md6 class="pr-1">
                                                        <v-text-field
                                                                solo
                                                                v-model="productPricePerKgL"
                                                                label="Prix par Kg ou L"
                                                                required
                                                                type="number"
                                                                suffix="CDF"
                                                                :rules="priceRules"
                                                        >
                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs md6 class="pl-1">
                                                        <v-text-field
                                                                solo
                                                                v-model="unit"
                                                                label="Unité"
                                                                type="text"
                                                                required
                                                        >
                                                        </v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-layout row wrap>
                                                    <v-flex xs12 md6 class="pr-1">
                                                        <v-btn block dark class="primary" @click="registerProduct"><b>Enregistrer</b></v-btn>
                                                    </v-flex>
                                                    <v-flex xs12 md6 class="pl-1">
                                                        <v-btn block @click.native="productDialog = !productDialog"><b>Annuler</b></v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-form>
                                    </v-flex>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-card style="border-radius: 10px">
                            <v-container>
                                <v-layout row wrap align-center>
                                    <v-flex xs12 md4>
                                        <v-img height="100px"
                                               src="/static/svgImages/farmer vector.svg"
                                               lazy-src="/static/svgImages/farmer vector.svg"
                                               aspect-ratio="1"
                                               contain
                                        >
                                        </v-img>
                                    </v-flex>
                                    <v-flex xs12 md8>
                                        <span style="font-size: 48px">4</span><br>
                                        <span style="font-size: 22px">Acheteur</span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
  export default {
    created  () {
      this.$store.dispatch('initRealTimeProducersListeners')
    },
    computed: {
      categoryNames () {
        return this.$store.getters.categoryNamesArray
      },
      producers () {
        return this.$store.state.producers
      },
      producersArray () {
        return this.$store.getters.producerNameArray
      },
      products () {
        return this.$store.state.products
      }
    },
    data () {
      return {
        producerDialog: false,
        productDialog: false,
        producerName: '',
        producerImageUrl: '',
        producerImage: '',
        state: '',
        description1: '',
        description2: '',
        description3: '',
        email: '',
        password: '',
        phoneNumber: '',
        states: [
          'Nord kivu',
          'Sud Kivu',
          'Kinshasa',
          'Kongo Centrale'
        ],
        model: null,
        productName: '',
        productProducer: '',
        productPrice: null,
        soldAs: '',
        soldAsOf: '',
        productPricePerKgL: null,
        available: '',
        discount: null,
        category: '',
        unit: '',
        emailRules: [
          v => !!v || 'E-mail est requis',
          v => /.+@.+/.test(v) || "L'email doit être valide"
        ],
        passwordRules: [
          v => !!v || 'Mot de passe est requis'
        ],
        nameRules: [
          (v) => !!v || 'Ces noms sont requis',
          (v) => /^[a-zA-Z' a-zA-Z a-zA-Z']{2,32}$/.test(v) || 'Les Noms doivent être valides'
        ],
        description: [
          (v) => !!v || 'Cette description est requise',
          (v) => /^\s*([^\r\n]+)\s*$/.test(v) || 'Elle doit être valide'
        ],
        phoneRules: [
          (v) => !!v || 'Votre tel est requis',
          (v) => /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/.test(v) || 'Le numero doit être valide'
        ],
        priceRules: [
          (v) => !!v || 'Le prix en mauvais format',
          (v) => /^\d+(,\d{3})*(\.\d{1,2})?$/.test(v) || 'Le prix doit être valide'
        ]
      }
    },
    methods: {
      onPickFile () {
        this.$refs.fileInput.click()
      },
      onFilePicked (event) {
        const files = event.target.files
        let filename = files[0].name
        if (filename.lastIndexOf('.') <= 0) {
          return alert('Please add a valid file')
        }
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          this.producerImageUrl = fileReader.result
        })
        fileReader.readAsDataURL(files[0])
        this.producerImage = files[0]
        console.log(this.producerImage)
      },
      registerProducer () {
        if (this.$refs.form.validate()) {
          this.$store.dispatch('REGISTER_PRODUCER',
            {
              producerName: this.producerName,
              producerImage: this.producerImage,
              state: this.state,
              description1: this.description1,
              description2: this.description2,
              description3: this.description3,
              phoneNumber: this.phoneNumber,
              email: this.email
            })
          this.producerDialog = false
        }
      },
      registerProduct () {
        if (this.$refs.form1.validate()) {
          this.$store.dispatch('REGISTER_PRODUCT',
            {
              productName: this.productName,
              productProducer: this.productProducer,
              category: this.category,
              productPrice: this.productPrice,
              productImage: this.producerImage,
              soldAs: this.soldAs,
              soldAsOf: this.soldAsOf,
              productPricePerKgL: this.productPricePerKgL,
              available: this.available,
              discount: this.discount,
              unit: this.unit,
              qty: 1
            })
          this.productDialog = false
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/adminDashboard/Index.vue